import MuiDialog, { DialogProps } from "@mui/material/Dialog";

const Dialog: React.FC<DialogProps> = MuiDialog;

export default Dialog;

export type { DialogProps };
